export default "__VITE_ASSET___0vcap$6__"